import React from 'react';
import PropTypes from 'prop-types';
import {YoutubeVideoEmbed} from 'epic-react-common';
// import { generateAppPath } from 'epic-common/src/route';

class VideoBlock extends React.Component {
    static propTypes = {
        bgImage: PropTypes.string,
        subTitle1: PropTypes.string,
        title: PropTypes.string,
        buttonText: PropTypes.string,
        videoId: PropTypes.string
    }

    constructor(props) {
        super(props);
        this.onClickWatch = this.__onClickWatch.bind(this, null);
    }
    state = {
        play: false
    }

    __onClickWatch() {
        this.setState({
            play: true
        });
    }
    render() {
        // const homeLink = generateAppPath('/home');
        const {
            bgImage, subTitle1, title, buttonText, videoId
        } = this.props;
        const style = {
            backgroundImage: `url(${bgImage})`
        };

        return (
            <section className="featured-video">
                <div
                    className="grid"
                    style={style}>
                    <div className="">
                        <div className="video-container">
                            <div className={`embed-container ${this.state.play ? 'show' : 'hidden'}`}>
                                <YoutubeVideoEmbed
                                    video={videoId}
                                    play={this.state.play} />
                            </div>
                            <div className={`copy ${this.state.play ? 'hidden' : 'show'}`}>
                                <h5>{subTitle1}</h5>
                                <h1>{title}</h1>
                                <button className="btn alt" id="play-video" onClick={this.onClickWatch}>
                                    {buttonText}
                                    <i className="fa fa-play-circle" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default VideoBlock;
